<template>
  <div class="passed-badge">
    <div class="scale-container">
      <span
        v-for="(p, i) in visiblePeople"
        :key="i"
        class="round-badge"
      >{{
        getLastName(p)
      }}</span>
      <span
        v-if="passedList.length > 3"
        class="round-badge"
      >...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassedBadge',
  props: {
    passedList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visiblePeople() {
      return this.passedList.slice(0, 3);
    },
  },
  methods: {
    getLastName(p) {
      if (p.real_name) {
        return p.real_name.slice(-2);
      }
      if (p.dd_student_name) {
        return p.dd_student_name.slice(-2);
      }
      return '-';
    },
  },
};
</script>

<style lang="scss" scoped>
// 设计图字体大小为 8 px
// 浏览器最小支持12px 字体大小
// 所以使用缩放
.passed-badge {
  width: 148px;
  height: 41px;
  line-height: 41px;
  position: relative;
  .scale-container {
    position: absolute;
    font-size: 16px;
    color: #fff;
  }
  .round-badge {
    display: inline-block;
    background-color: #0089ff;
    // prettier-ignore
    border: 1PX solid #EFF3F7;
    width: 39px;
    height: 39px;
    border-radius: 50%;
    margin-left: -12px;
    line-height: 40px;
    text-align: center;
    vertical-align: top;
    overflow: hidden;
  }
  .round-badge:nth-child(1){
    margin-left: 0;
  }
}
</style>
